import { AccountCircle, Logout, Person } from '@mui/icons-material'
import {
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  SxProps,
  Theme,
  useTheme,
} from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import preloadAccountPortalRoutes from '~/app/utils/lazy/accountPortalLazyLoadingUtils'
import useSignOut from '~/features/auth/hooks/useSignOut'
import { EClientPath } from '~/models/api'
import rem from '~/utils/ui'

type TProps = {
  sx?: SxProps<Theme>
  colorTrigger: boolean
}

function MarketingAccount({ colorTrigger, sx = {} }: TProps) {
  const theme = useTheme()
  const navigate = useNavigate()
  const { signOut } = useSignOut()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const openMenuHandler = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenuHandler = () => {
    setAnchorEl(null)
  }

  const handleMyAccountMouseOver = () => {
    preloadAccountPortalRoutes()
  }

  return (
    <Box sx={sx}>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={openMenuHandler}
        sx={{
          color: colorTrigger ? theme.palette.grey[600] : 'inherit',
        }}
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClick={closeMenuHandler}
        onClose={closeMenuHandler}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: `drop-shadow(${rem(0)} ${rem(2)} ${rem(8)} ${
                theme.palette.grey[500]
              })`,
              mt: 7,
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 20,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
      >
        <MenuItem
          onClick={() => navigate(EClientPath.overview)}
          onMouseOver={handleMyAccountMouseOver}
        >
          <ListItemIcon>
            <Person fontSize="small" />
          </ListItemIcon>
          My account
        </MenuItem>

        <MenuItem onClick={signOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default MarketingAccount
